import React, { useState } from 'react'
import * as R from 'ramda'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import {
  Typography,
  IconButton,
  Icon,
  CircularProgress,
} from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import moment from 'moment'
import MessageAlert from 'app/components/MessageAlert'
import Assets from 'app/configs/assetConfigs'
import SecondaryButton from 'app/components/buttons/SecondaryButton'

import { useDispatch } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  creditCard: {
    width: '75px',
  },
  cardNumber: {
    'letter-spacing': '2px',
    fontWeight: 'bold',
  },
}))

const getCardNumber = (lastFourDigit) =>
  R.compose(
    R.join(' '),
    R.splitEvery(4),
    R.concat(R.__, lastFourDigit),
    R.join(''),
    R.repeat('•'),
  )(12)

export const PlanBillingCreditCard = (props) => {
  const {
    cardBand,
    cardLastFour,
    expirationMonth,
    expirationYear,
    className,
    onDelete,
    onClick = () => {},
    paymentMethod,
    hiddenExpires,
    isDefault,
  } = props

  const { formatMessage } = useIntl()
  const [isLoading, setIsLoading] = useState(false)
  const reduxDispatch = useDispatch()
  const handleLoadingState = (fn) => async (data) => {
    setIsLoading(true)
    try {
      await fn(data)
    } catch (error) {
      reduxDispatch(MessageAlert.showNetworkError(formatMessage)(error))
    } finally {
      setIsLoading(false)
    }
  }
  const handleDeleteWithHandleLoadingState = handleLoadingState(onDelete)
  const handleSetDefaultWithHandleLoadingState = handleLoadingState(onClick)
  const classes = useStyles()
  return (
    <div
      className={clsx(
        'flex items-center relative',
        className,
        classes.cardHeight,
      )}
    >
      <img
        src={Assets.paymentMethodLogo[cardBand]}
        alt="logo-card"
        width={140}
      />
      <div className="flex-col space-y-5 m-10">
        <Typography className={classes.cardNumber}>
          {getCardNumber(cardLastFour)}
        </Typography>
        <Typography>
          <FormattedMessage id="planAndBilling.paymentMethod.card.creditCard" />
        </Typography>
        {!onDelete && !hiddenExpires && (
          <Typography>
            <FormattedMessage
              id="planAndBilling.yourPlan.paymentMethod.expires"
              values={{
                b: (text) => <b>{text}</b>,
                date: moment()
                  .month(expirationMonth - 1)
                  .year(expirationYear)
                  .format('MM / YY'),
              }}
            />
          </Typography>
        )}
      </div>
      {onDelete && (
        <CardIcon
          isDefault={isDefault}
          isLoading={isLoading}
          onSetDefault={() => {
            handleSetDefaultWithHandleLoadingState(
              R.prop('token', paymentMethod),
            )
          }}
          onDelete={(e) => {
            e.stopPropagation()
            handleDeleteWithHandleLoadingState(R.prop('token', paymentMethod))
          }}
        />
      )}
    </div>
  )
}

const CardIcon = ({ isDefault, onSetDefault, isLoading, onDelete }) => {
  const classes = useStyles()
  if (isDefault) {
    if (isLoading) {
      return <CircularProgress className="self-center m-12 ml-auto w-24 h-24" />
    }
    return (
      <Typography className="italic ml-auto ltr:mr-24 rtl:ml-24 font-bold">
        <FormattedMessage id="planAndBilling.paymentMethod.card.defaultCard" />
      </Typography>
    )
  }

  return isLoading ? (
    <CircularProgress className="self-center m-12  ml-auto  w-24 h-24" />
  ) : (
    <div className="ml-auto">
      <SecondaryButton
        className="normal-case text-blue-primary"
        labelId="planAndBilling.paymentMethod.card.setAsDefaultCard"
        onClick={onSetDefault}
      />
      <IconButton
        key="close"
        aria-label="Close"
        className={clsx(classes.closeIcon)}
        onClick={onDelete}
      >
        <Icon>delete_outline</Icon>
      </IconButton>
    </div>
  )
}
